import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Layout } from "antd";
import { useEffect } from "react";

const { Content } = Layout;

const FONT_LINK_ID = "final-page-font";
const FONT_URL = "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;800&display=swap";

export const Route = createFileRoute("/$tenantSlug/processes/_layout")({
    component: ProcessLayoutComponent,
});

function ProcessLayoutComponent() {
    useEffect(() => {
        if (document.getElementById(FONT_LINK_ID)) {
            return;
        }
        const link = document.createElement("link");
        link.id = FONT_LINK_ID;
        link.rel = "stylesheet";
        link.href = FONT_URL;
        document.head.appendChild(link);
        return () => link.remove();
    }, []);

    return (
        <Layout className={"bg-[#fdfdfd] overflow-y-scroll"}>
            <Content className={"m-5"}>
                <div className="flex flex-1 justify-center items-center h-full">
                    <main className="">
                        <Outlet />
                    </main>
                </div>
            </Content>
        </Layout>
    );
}
